/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class VerticalGroupingHistory extends Ce {
    constructor() {
        super();
        this.baseUrl += '/verticalGroupingHistory';
    }

    data({ certCatId, verticalGroupingSn, fullName, idCardNo, mobile, examTime, currentPage, pageSize } = {}) {
        let examTimeBegin = null;
        let examTimeEnd = null;
        if (examTime != null && examTime.length === 2) {
            [examTimeBegin, examTimeEnd] = examTime;
        }
        return super.get('/data', {
            certCatId,
            verticalGroupingSn,
            fullName,
            idCardNo,
            mobile,
            examTimeBegin,
            examTimeEnd,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    save({
        id,
        certCatId,
        verticalGroupingSn,
        seatNumber,
        fullName,
        sex,
        idCardType,
        idCardNo,
        mobile,
        examTime,
    } = {}) {
        return super.post('/save', {
            id,
            certCatId,
            verticalGroupingSn,
            seatNumber,
            fullName,
            sex,
            idCardType,
            idCardNo,
            mobile,
            examTime,
        });
    }
}

export default new VerticalGroupingHistory();
export { VerticalGroupingHistory };
